import { Api } from './api';
import type { AddProduct, IProduct, UpdateProduct } from '../types';
import { formData } from '../utils/formData';

export class ProductsApi extends Api {

  public static async getProdutcs(query?: { name?: string; limit?: number }) {
    return this.get<IProduct[]>('/product', { params: query });
  }

  public static async add(product: AddProduct) {
    return this.post<IProduct>('/product', formData({
      name: product.name,
      key: product.key,
      type: product.type,
      category: product.category,
      profitType: product.profitType,
      profit: product.profit.toString(),
      min: product.min?.toString(),
      max: product.max?.toString(),
      image: product.image,
      instructions: product.instructions,
      prices: JSON.stringify(product.prices)
    }));
  }

  public static async update(id: number, product: UpdateProduct) {
    return this.patch<IProduct>(`/product/${id}`, formData({
      name: product.name,
      key: product.key,
      type: product.type,
      category: product.category,
      profitType: product.profitType,
      profit: product.profit.toString(),
      min: product.min?.toString(),
      max: product.max?.toString(),
      image: product.image,
      instructions: product.instructions,
      prices: JSON.stringify(product.prices)
    }));
  }

  public static async enable(id: number, enabled: boolean) {
    await this.patch(`/product/${id}`, { enabled });
  }
}
